import { useDevToolsStore } from '@frontend/devtools';
import { theme } from '@frontend/theme';
import { Accordion } from '@frontend/design-system';
import { useCheckPaymentsEnabled } from '../../../../../../../hooks/use-check-payments-enabled';
import { ScheduleRequestsTrackingIds } from '../../trackingIds';
import { ScheduleRequestDetails } from '../ScheduleRequestDetails';
import { ScheduleRequestItemHeader, ScheduleRequestItemHeaderProps } from '../ScheduleRequestItemHeader';

export const SchedulePulseRequestListItem = (props: ScheduleRequestItemHeaderProps) => {
  const { listItem } = props;
  const { isPaymentsEnabled } = useCheckPaymentsEnabled(listItem.locationId);
  const isDebugModeOn = useDevToolsStore((state) => state.options.isDebugModeOn);

  return (
    <Accordion.Item
      trackingId={ScheduleRequestsTrackingIds.requestListItemAccordion}
      style={{ borderBottom: `1px solid ${theme.colors.neutral10}` }}
      value={listItem?.id ?? ''}
      key={listItem?.id ?? ''}
    >
      <Accordion.Header
        css={isDebugModeOn && listItem.linkHash === 'v2' ? { backgroundColor: theme.colors.critical10 } : undefined}
      >
        <ScheduleRequestItemHeader {...props} />
      </Accordion.Header>

      <Accordion.Body>
        <ScheduleRequestDetails
          requestVersion={listItem.linkHash || ''}
          scheduleRequestId={listItem.id ?? ''}
          locationId={listItem.locationId ?? ''}
          isPaymentsEnabled={isPaymentsEnabled}
        />
      </Accordion.Body>
    </Accordion.Item>
  );
};
